import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useTenant } from '@/contexts/TenantContext';
import { Loader2, Lock } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminLogin({ onLogin }) {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const appName = tenant?.name || 'Shangrilux';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Accesso effettuato');
      // Preserve ?tenant= query param after login
      navigate(`/panel${window.location.search}`);
      if (onLogin) onLogin();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Credenziali non valide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-[var(--lux-bg)] flex items-center justify-center px-4"
      style={{ backgroundImage: 'radial-gradient(ellipse at top center, rgba(201,168,76,0.05) 0%, transparent 60%)' }}
    >
      <div className="w-full max-w-sm fade-in">
        <div className="text-center mb-10">
          <div className="w-12 h-12 border border-[#c9a84c]/40 rounded-full flex items-center justify-center mx-auto mb-5">
            <Lock size={20} className="text-[#c9a84c]" strokeWidth={1.5} />
          </div>
          <h1 className="font-serif text-3xl font-light text-white">{appName}</h1>
          <p className="label-muted mt-2">Pannello di Controllo</p>
        </div>

        <form
          onSubmit={handleSubmit}
          data-testid="admin-login-form"
          className="bg-[#121212] border border-[#222] rounded-lg p-8 space-y-5"
        >
          <div>
            <label className="label-muted block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="admin@esempio.it"
              className="input-dark"
              data-testid="login-email-input"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="label-muted block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              className="input-dark"
              data-testid="login-password-input"
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-gold w-full flex items-center justify-center gap-2"
            data-testid="login-submit-btn"
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}
